module.exports = __webpack_public_path__ + "faa8d29ad3fab1b100c97a106fb4d23b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2026-02-04/whats-new.html
// module id = 2345
// module chunks = 0